/**
 * Frontend route access policy for legacy / internal tooling paths.
 * Router guards are UX-only; APIs remain separately protected.
 *
 * Backend follow-up (not implemented here): mount submit-survey behind dev auth,
 * nginx blocks for /calculation-records and /rules in production, disable OpenAPI in prod.
 */

export const PUBLIC_ROUTE_PATHS = [
  '/new',
  '/client',
  '/entry',
  '/signin',
  '/register',
  '/claim-account',
  '/forgot-password',
  '/reset-password',
] as const;

export type PublicRoutePath = (typeof PUBLIC_ROUTE_PATHS)[number];

export const INTERNAL_ROUTE_PATHS = [
  '/',
  '/dashboard',
  '/tax-calculation',
  '/extraction',
  '/rules',
  '/questionnaire',
  '/screens',
  '/calculation-records',
] as const;

export type InternalRoutePath = (typeof INTERNAL_ROUTE_PATHS)[number];

/** Paths that never use a ProtectedRoute wrapper. */
export function isPublicRoutePath(path: string): boolean {
  return (PUBLIC_ROUTE_PATHS as readonly string[]).includes(path);
}

/**
 * Legacy tooling routes: open in development or when explicitly enabled at build time.
 */
export function canAccessInternalRoutes(): boolean {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return process.env.REACT_APP_LEGACY_ROUTES_ENABLED === 'true';
}

/** Default redirect for unknown paths and blocked internal routes. */
export function getDefaultPublicRedirectPath(): string {
  return '/new';
}
